import React from "react";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Users, ClipboardList, Image, FileText } from "lucide-react";
import type { OperationsTabValue } from "../types";

interface OperationsTabsHeaderProps {
  activeTab: string;
}

export const OperationsTabsHeader: React.FC<OperationsTabsHeaderProps> = ({
  activeTab,
}) => {
  return (
    <TabsList className="flex h-14 w-full items-stretch rounded-xl border border-slate-200 bg-white p-0 shadow-sm overflow-hidden mb-6">
      <TabsTrigger
        value="influencers"
        className="relative flex flex-1 items-center justify-center bg-transparent transition-all duration-200 text-slate-800 data-[state=active]:!text-[#A655F8] data-[state=active]:!bg-[#A655F8]/[0.06] data-[state=active]:!shadow-none focus-visible:outline-none py-0 px-2 rounded-none font-['Hanken_Grotesk',sans-serif]"
      >
        <div className="relative flex items-center gap-1.5 md:gap-2 h-full">
          <Users className="h-4 w-4 md:h-4.5 md:w-4.5" />
          <span className="text-xs sm:text-sm md:text-[15px] font-semibold whitespace-nowrap">
            Influencers
          </span>
          {activeTab === "influencers" && (
            <div className="absolute bottom-0 left-0 right-0 h-[2.5px] rounded-t-full bg-[#A655F8]" />
          )}
        </div>
      </TabsTrigger>

      <div className="h-6 w-[1px] bg-slate-200 self-center shrink-0" />

      <TabsTrigger
        value="deliverables"
        className="relative flex flex-1 items-center justify-center bg-transparent transition-all duration-200 text-slate-800 data-[state=active]:!text-[#A655F8] data-[state=active]:!bg-[#A655F8]/[0.06] data-[state=active]:!shadow-none focus-visible:outline-none py-0 px-2 rounded-none font-['Hanken_Grotesk',sans-serif]"
      >
        <div className="relative flex items-center gap-1.5 md:gap-2 h-full">
          <ClipboardList className="h-4 w-4 md:h-4.5 md:w-4.5" />
          <span className="text-xs sm:text-sm md:text-[15px] font-semibold whitespace-nowrap">
            Deliverables
          </span>
          {activeTab === "deliverables" && (
            <div className="absolute bottom-0 left-0 right-0 h-[2.5px] rounded-t-full bg-[#A655F8]" />
          )}
        </div>
      </TabsTrigger>

      <div className="h-6 w-[1px] bg-slate-200 self-center shrink-0" />

      <TabsTrigger
        value="content"
        className="relative flex flex-1 items-center justify-center bg-transparent transition-all duration-200 text-slate-800 data-[state=active]:!text-[#A655F8] data-[state=active]:!bg-[#A655F8]/[0.06] data-[state=active]:!shadow-none focus-visible:outline-none py-0 px-2 rounded-none font-['Hanken_Grotesk',sans-serif]"
      >
        <div className="relative flex items-center gap-1.5 md:gap-2 h-full">
          <Image className="h-4 w-4 md:h-4.5 md:w-4.5" />
          <span className="text-xs sm:text-sm md:text-[15px] font-semibold whitespace-nowrap">
            Content Gallery
          </span>
          {activeTab === "content" && (
            <div className="absolute bottom-0 left-0 right-0 h-[2.5px] rounded-t-full bg-[#A655F8]" />
          )}
        </div>
      </TabsTrigger>

      <div className="h-6 w-[1px] bg-slate-200 self-center shrink-0" />

      <TabsTrigger
        value="notes"
        className="relative flex flex-1 items-center justify-center bg-transparent transition-all duration-200 text-slate-800 data-[state=active]:!text-[#A655F8] data-[state=active]:!bg-[#A655F8]/[0.06] data-[state=active]:!shadow-none focus-visible:outline-none py-0 px-2 rounded-none font-['Hanken_Grotesk',sans-serif]"
      >
        <div className="relative flex items-center gap-1.5 md:gap-2 h-full">
          <FileText className="h-4 w-4 md:h-4.5 md:w-4.5" />
          <span className="text-xs sm:text-sm md:text-[15px] font-semibold whitespace-nowrap">
            Notes & Tasks
          </span>
          {activeTab === "notes" && (
            <div className="absolute bottom-0 left-0 right-0 h-[2.5px] rounded-t-full bg-[#A655F8]" />
          )}
        </div>
      </TabsTrigger>
    </TabsList>
  );
};
